import React, { Suspense, lazy } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import MarketingConsent from "./components/MarketingConsent";
import LandingPage from "./components/LandingPage";
import "./components/content.css";

const ProductPage = lazy(() => import("./components/ProductPage"));
const AboutPage = lazy(() => import("./components/AboutPage"));
const LogicWikiPage = lazy(() => import("./components/LogicWikiPage"));
const NotFoundPage = lazy(() => import("./components/NotFoundPage"));

function App() {
  return (
    <BrowserRouter>
      <MarketingConsent />
      <Suspense fallback={<div className="pcb-root min-h-screen" aria-label="Loading page" />}>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/product/:productId" element={<ProductPage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/logic-wiki" element={<LogicWikiPage />} />
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </Suspense>
    </BrowserRouter>
  );
}

export default App;
